import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function Results() {
  const results = ['Bajar la aceleración un poco más rápido', 'Dormir un poco mejor', 'Hablarte menos cruel', 'Dejar de interpretar todo como señal', 'Sostener un ritual incluso con días feos'];
  return <Section className="bg-white/50 rounded-3xl my-8" data-id="element-172">
      <div className="text-center mb-10" data-id="element-173">
        <h2 className="text-3xl font-serif mb-2 text-warm-brown" data-id="element-174">
          Qué vas a lograr en 7 días
        </h2>
        <p className="text-sage italic" data-id="element-175">(realista)</p>
      </div>

      <ul className="space-y-4 mb-10 pl-4 md:pl-12" data-id="element-176">
        {results.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-177">
            <span className="mt-1 bg-sage/20 p-1 rounded-full text-sage" data-id="element-178">
              <Check size={14} strokeWidth={3} data-id="element-179" />
            </span>
            <span className="text-lg text-warm-brown/90" data-id="element-180">{item}</span>
          </li>)}
      </ul>

      <div className="text-center border-t border-sage/10 pt-8" data-id="element-181">
        <p className="font-serif text-xl text-warm-brown" data-id="element-182">
          No te vendo iluminación. <br className="md:hidden" data-id="element-183" />
          <strong className="text-terracotta" data-id="element-184">
            Te vendo habitabilidad interna.
          </strong>
        </p>
      </div>
    </Section>;
}